import { REQUEST_UNSUBSCRIBE, SUCCESS_UNSUBSCRIBE, FAILURE_UNSUBSCRIBE } from './constants';
import { combineReducers } from 'redux';

/** State shape
 * {
    fetching: false,
    successUnsubscribeRequestSubmit: false,
    errorMessage: ''
 * }
 */

const successUnsubscribeRequestSubmit = (state = false, action) => {
    switch (action.type) {
        case SUCCESS_UNSUBSCRIBE:
            return true;
        case REQUEST_UNSUBSCRIBE:
        case FAILURE_UNSUBSCRIBE:
            return false;
        default:
            return state;
    }
};

const fetching = (state = false, action) => {
    switch (action.type) {
        case REQUEST_UNSUBSCRIBE:
            return true;
        case FAILURE_UNSUBSCRIBE:
        case SUCCESS_UNSUBSCRIBE:
            return false;
        default:
            return state;
    }
};

const error = (state = '', action) => {
    switch (action.type) {
        case FAILURE_UNSUBSCRIBE:
            return action.response.message;
        case REQUEST_UNSUBSCRIBE:
        case SUCCESS_UNSUBSCRIBE:
            return '';
        default:
            return state;
    }
};

export default combineReducers({ successUnsubscribeRequestSubmit, fetching, error });



// WEBPACK FOOTER //
// ./src/services/unsubscribe/reducer.js